/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Knoxsecure
 */
export class Knoxsecure {
    /**
     *
     * @type {string}
     * @memberof Knoxsecure
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Knoxsecure
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Knoxsecure
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Knoxsecure
     */
    secretKey: string;
    /**
     *
     * @type {string}
     * @memberof Knoxsecure
     */
    applicationKey: string;
    /**
     *
     * @type {boolean}
     * @memberof Knoxsecure
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Knoxsecure
     */
    autoApprove: boolean;
}
